import Image from "next/image"

const EventMakingSectionCompany = () => {
    return (
        <div>
            <div className="relative bg-gradient-to-t from-black">
                <div className="h-screen w-full overflow-hidden">
                    <Image
                        src="https://cdn.pass-tickets.com/frontend/concert (1).png"
                        alt="bit rate"
                        width={0}
                        height={0}
                        layout="responsive"
                        objectFit="cover"
                        className="h-screen w-full bg-cover bg-center opacity-40 lg:h-80"
                    />
                </div>

                <div className="h-full w-full">
                    <p className="W-20 absolute top-20 truncate break-words text-xl font-bold text-white lg:top-40 lg:mx-36 lg:leading-9">
                        صناعة الفعاليات <br /> في باس تيكتس
                    </p>
                    <div className="absolute top-36 z-10 flex flex-col gap-4 text-right text-white lg:top-72 lg:mx-36 lg:w-2/4">
                        <p className="text-2xl font-bold text-white lg:text-start lg:text-4xl lg:leading-9">
                            صناعة الفعاليات للشركات
                        </p>
                        <p className="text-right text-xl font-normal text-white lg:leading-10">
                            نقدم خدمات صناعة فعاليـات مـتخصصة للـشركات بدءًا من
                            مناسبات الشركات وطرح المنتجات الجديدة، إلى المؤتمرات
                            والمعارض، ومتاجر المواسم، و ورش الـعمل، وحفلات
                            المهرجانات، والتفعيلات العامة في الامـاكن الـعامة.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EventMakingSectionCompany
